module.exports = __webpack_public_path__ + "static/img/redpack-withdraw.47fe658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/redpack-withdraw.png
// module id = mRv0
// module chunks = 215